// Typed text is only overwritten after a confirm; an empty box, or one already holding
// the replacement, is filled straight away.
export function shouldConfirmReplace(currentText: string, replacement: string): boolean {
    const current = currentText.trim();
    return current !== '' && current !== replacement.trim();
}
